export default __webpack_public_path__ + "static/media/app-store-it.29f00073.svg";